import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function TraditionalMethods() {
  const methods = [{
    title: 'EL CASTIGO',
    quote: '"Si no te calmas, te quedas sin tablet."',
    problem: 'Cuando el niño está en colapso emocional, el cerebro racional está APAGADO. El castigo no llega. Solo añade miedo sobre el caos.',
    result: 'Más llanto, más tensión, tú más frustrado.'
  }, {
    title: 'LA EXPLICACIÓN LÓGICA',
    quote: '"Hijo, entiende que no podemos comprarlo todo..."',
    problem: 'Un niño desbordado no puede procesar un discurso. La puerta de la razón está cerrada con llave desde adentro.',
    result: 'Él sigue llorando, tú sigues hablando, nadie escucha.'
  }, {
    title: 'EL SOBORNO',
    quote: '"Si dejas de llorar te doy un dulce."',
    problem: 'Le enseñas que el berrinche es la moneda de cambio para conseguir lo que quiere.',
    result: 'Más berrinches, más seguidos, más estratégicos.'
  }, {
    title: 'GRITAR MÁS FUERTE',
    quote: 'Ya lo intentaste. Sabes que no funciona.',
    problem: 'Solo demuestra que quien grita más fuerte gana temporalmente. Esa no es la lección que quieres dar.',
    result: 'Ciclo de escalada y culpa de la noche también.'
  }];
  return <section className="py-20 px-6 bg-brand-bg" data-id="element-369">
      <div className="max-w-4xl mx-auto" data-id="element-370">
        <FadeIn data-id="element-371">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-372">
            Probablemente ya intentaste alguna de estas cosas
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12" data-id="element-373">
            Y no funcionó. Esto es exactamente por qué.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-374">
          {methods.map((method, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-375">
              <div className="bg-white border-l-4 border-red-500 rounded-r-2xl p-6 shadow-sm h-full flex flex-col" data-id="element-376">
                <div className="flex items-center gap-3 mb-4" data-id="element-377">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-378" />
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-379">
                    {method.title}
                  </h3>
                </div>

                <div className="bg-gray-50 p-4 rounded-xl mb-4 italic text-gray-700 text-sm" data-id="element-380">
                  {method.quote}
                </div>

                <div className="space-y-3 flex-1" data-id="element-381">
                  <p className="text-gray-700 text-sm leading-relaxed" data-id="element-382">
                    <span className="font-bold text-red-800" data-id="element-383">
                      🧠 Por qué falla:
                    </span>
                    <br data-id="element-384" />
                    {method.problem}
                  </p>

                  <p className="text-gray-700 text-sm leading-relaxed" data-id="element-385">
                    <span className="font-bold text-red-800" data-id="element-386">
                      📉 Resultado:
                    </span>
                    <br data-id="element-387" />
                    {method.result}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-388">
          <div className="bg-brand-cream rounded-3xl p-8 md:p-10 text-center max-w-2xl mx-auto" data-id="element-389">
            <p className="text-xl font-medium text-gray-800 mb-4" data-id="element-390">
              Ninguno falla porque seas mal padre o mala madre.
            </p>
            <p className="text-xl font-medium text-gray-800 mb-6" data-id="element-391">
              Fallan porque atacan el síntoma en lugar del origen.
            </p>
            <div className="h-px bg-gray-300 my-6" data-id="element-392"></div>
            <p className="text-lg text-gray-700 mb-4" data-id="element-393">
              Tu hijo no está eligiendo portarse mal.
              <br data-id="element-394" />
              Está teniendo un colapso del sistema nervioso.
            </p>
            <p className="text-xl font-bold text-brand-sage" data-id="element-395">
              Y eso tiene una solución diferente.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}